// Must be imported before any jQuery plugin: they (and the Propshaft-served
// admin scripts and inline view tags) expect jQuery on the window.
import jquery from "jquery";

window.jQuery = window.$ = jquery;
